export const MONACO_LANG = {
  71: "python",
  62: "java",
  54: "cpp",
  50: "c",
  63: "javascript",
  74: "typescript"
};

export const LANGUAGE_VERSIONS = {
  javascript: "18.15.0",
  typescript: "5.0.3",
  python: "3.10.0",
  java: "15.0.2",
  c: "10.2.0",
  cpp: "10.2.0"
};